import React, { useState, useEffect } from 'react';
import { IonApp, IonContent, IonPage, setupIonicReact } from '@ionic/react';
import { BrowserRouter as Router } from 'react-router-dom';
import { AppRoutes } from './AppRoutes';
import { Sidebar } from './components/Sidebar/Sidebar';
import { TopNav } from './components/TopNav/TopNav';
import { PageTransition } from './components/PageTransition/PageTransition';
import { ToastProvider, ScrollProgress } from './components';
import { ThemeProvider } from './theme/ThemeContext';
import './theme/globals.scss';

setupIonicReact();

export const App: React.FC = () => {
  const [sidebarExpanded, setSidebarExpanded] = useState(false);
  const [mobileMenuOpen, setMobileMenuOpen] = useState(false);
  const [isMobile, setIsMobile] = useState(window.innerWidth < 768);

  useEffect(() => {
    const handleResize = () => {
      const mobile = window.innerWidth < 768;
      setIsMobile(mobile);
      if (!mobile) {
        setMobileMenuOpen(false);
      }
    };

    window.addEventListener('resize', handleResize);
    return () => window.removeEventListener('resize', handleResize);
  }, []);

  return (
    <ThemeProvider>
      <ToastProvider>
        <IonApp>
          <Router>
            <ScrollProgress />
            <div className="app-container">
            <TopNav
              setMobileMenuOpen={setMobileMenuOpen}
              isMobile={isMobile}
            />
            <div className="content-wrapper">
              <Sidebar
                expanded={sidebarExpanded}
                setExpanded={setSidebarExpanded}
                mobileMenuOpen={mobileMenuOpen}
                setMobileMenuOpen={setMobileMenuOpen}
                isMobile={isMobile}
              />
              <main className="main-content">
                <IonContent className="page-content">
                  <IonPage>
                    <PageTransition>
                      <AppRoutes />
                    </PageTransition>
                  </IonPage>
                </IonContent>
              </main>
            </div>
          </div>
        </Router>
      </IonApp>
    </ToastProvider>
    </ThemeProvider>
  );
};
